import { css } from 'goober'

export const fillAbsClass = css`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
`

export const scFrameClass = css`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
`
